import Header from "./components/common/header.vue";
import Footer from "./components/common/footer.vue";
import jquery from 'jquery';
export default{
     // 设置全局方法
     install(vue,params){
        vue.prototype.apiUrl = "http://106.14.53.17/bsp";
        vue.component('Header',Header);
        vue.component('Footer',Footer);
        vue.prototype.$jq = jquery;
    }
} 


// WEBPACK FOOTER //
// ./src/config.js